import type { ReadonlyDeep } from 'type-fest';

import { ResolvableServiceValueInput } from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';

import { pruneInput } from '../../../utils/prune-input.util';

import { resolvableAmountForm2ApiMapper } from '../../ResolvableField/mappers/resolvable-amount.form2api.mapper';
import { resolvableIdForm2ApiMapper } from '../../ResolvableField/mappers/resolvable-id.form2api.mapper';
import { resolvableFloatForm2ApiMapper } from '../../ResolvableField/mappers/resolvable-float.form2api.mapper';

import type { ResolvableServiceForm_ResolvableServiceBaseInterface } from '../fragments/resolvable-service-base-interface.fragment';

export function resolvableServiceValueForm2ApiMapper(
  resolvableServiceValue: ReadonlyDeep<ResolvableServiceForm_ResolvableServiceBaseInterface>['value'],
): ReadonlyDeep<ResolvableServiceValueInput> {
  const resolvableServiceValueInput = pruneInput(
    resolvableServiceValue,
    ResolvableServiceValueInput,
  );

  return {
    ...resolvableServiceValueInput,
    priceExcludingVat: resolvableAmountForm2ApiMapper(
      resolvableServiceValue.priceExcludingVat,
    ),
    vatId: resolvableIdForm2ApiMapper(resolvableServiceValue.vatId),
    ...(resolvableServiceValue.discountAmount
      ? {
          discountAmount: resolvableAmountForm2ApiMapper(
            resolvableServiceValue.discountAmount,
          ),
        }
      : EMPTY_OBJECT),
    ...(resolvableServiceValue.discountPercentage
      ? {
          discountPercentage: resolvableFloatForm2ApiMapper(
            resolvableServiceValue.discountPercentage,
          ),
        }
      : EMPTY_OBJECT),
  };
}
